export enum ReportFormatEnum {
  HTML = "HTML",
  CSV = "CSV",
  PDF = "PDF",
}
